// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, getRedirectResult, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC0olgbv26QB-YHXG5saki4ozdNgv9ZeMo",
  authDomain: "hackathon-hub.firebaseapp.com",
  projectId: "hackathon-hub",
  storageBucket: "hackathon-hub.appspot.com",
  messagingSenderId: "463654614315",
  appId: "1:463654614315:web:22877faeafaef61dad416e",
  measurementId: "G-CBR5491V6L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const provider = new GoogleAuthProvider();

export const firebaseInstance = app;
export const authService = getAuth();
// export const signIn = () => signInWithPopup(authService, provider);
export const signIn = () => getRedirectResult(authService);
